<template>
  <div id="app">
<!--    <Login/>-->
    <router-view></router-view>

  </div>
</template>

<script>
// import Login from './components/Login'

export default {
  name: 'App'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue